import axios from "axios";
import localStorage from "redux-persist/es/storage";
// const dev = process.env.REACT_APP_DEVELOPMENT
interface UserState {
  id: number;
  token: string;
}


export const fetchData = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const defaultOptions = {
    baseURL: BASE_URL,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  };
  let instance = axios.create(defaultOptions);

  instance.interceptors.request.use(async function (config) {
    let datos = await localStorage.getItem("persist:root");
    // console.log(datos)
    if (typeof datos === "string") {
      const parse = JSON.parse(datos); // ok
      const user: UserState = JSON.parse(parse.user); // ok
      /*   if(dev === 'true'){
        console.log('El token actual es: ',user.token)
      }   */
      /* console.log(user.token); */
      config.headers.Authorization = user.token ? `Bearer ${user.token}` : "";
    }
    return config;
  });

  instance.interceptors.response.use(
    response => response,
    error => {
      if (error.response && error.response.status === 401) {
        // Despacha la acción de logout
        localStorage.removeItem("persist:root");;

        // Redirige al usuario a la página de inicio de sesión
        window.location.href = '/login'; // Cambia esto si estás usando react-router
      }
      return Promise.reject(error);
    }
  );
  return instance;
};

export const fetchDataV2 = () => {
  const BASE_URL = process.env.REACT_APP_APIV2_URL || 'https://cp-employees.confiebeta.com/';
  const defaultOptions = {
    baseURL: BASE_URL,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  };
  let instance = axios.create(defaultOptions);

  instance.interceptors.request.use(async function (config) {
    let datos = await localStorage.getItem("persist:root");
    // console.log(datos)
    if (typeof datos === "string") {
      const parse = JSON.parse(datos); // ok
      const user: UserState = JSON.parse(parse.user); // ok
      /*   if(dev === 'true'){
        console.log('El token actual es: ',user.token)
      }   */
      /* console.log(user.token); */
      config.headers.Authorization = user.token ? `Bearer ${user.token}` : "";
    }
    return config;
  });

  instance.interceptors.response.use(
    response => response,
    error => {
      if (error.response && error.response.status === 401) {
        // Despacha la acción de logout
        localStorage.removeItem("persist:root");;

        // Redirige al usuario a la página de inicio de sesión
        window.location.href = '/login'; // Cambia esto si estás usando react-router
      }
      return Promise.reject(error);
    }
  );
  return instance;
};
